/*
 * @Author: gvodandan 2388176818@qq.com
 * @Date: 2024-11-18 16:24:57
 * @LastEditors: gvodandan 2388176818@qq.com
 * @LastEditTime: 2024-12-08 15:46:17
 * @FilePath: \no035_HotelManagementandRecommendationSys-master\vue\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { $local } from '@/utils/auth'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    redirect: '/login',
    component: () => import('../views/Manager.vue'),
    children: [
      { path: '403', name: 'NoAuth', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/manager/Home') },
      { path: 'admin', name: 'Admin', meta: { name: '管理员信息' }, component: () => import('../views/manager/Admin') },
      { path: 'adminPerson', name: 'AdminPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/AdminPerson') },
      { path: 'hotelPerson', name: 'HotelPerson', meta: { name: '个人信息' }, component: () => import('../views/manager/HotelPerson') },
      { path: 'history', name: 'History', meta: { name: '历史入住' }, component: () => import('../views/manager/History') },
      { path: 'password', name: 'Password', meta: { name: '修改密码' }, component: () => import('../views/manager/Password') },
      { path: 'notice', name: 'Notice', meta: { name: '公告信息' }, component: () => import('../views/manager/Notice') },
      { path: 'hotel', name: 'Hotel', meta: { name: '酒店信息' }, component: () => import('../views/manager/Hotel') },
      { path: 'user', name: 'User', meta: { name: '用户信息' }, component: () => import('../views/manager/User') },
      { path: 'type', name: 'Type', meta: { name: '分类信息' }, component: () => import('../views/manager/Type') },
      { path: 'room', name: 'Room', meta: { name: '客房信息' }, component: () => import('../views/manager/Room') },
      { path: 'orders', name: 'Orders', meta: { name: '订单信息' }, component: () => import('../views/manager/Orders') },
      { path: 'checkin', name: 'Checkin', meta: { name: '入住登记' }, component: () => import('../views/manager/Checkin') },
      { path: 'comment', name: 'Comment', meta: { name: '评论管理' }, component: () => import('../views/manager/Comment') },
    ]
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/Front.vue'),
    children: [
      { path: 'home', name: 'Home', meta: { name: '系统首页' }, component: () => import('../views/front/Home') },
      { path: 'history', name: 'History', meta: { name: '历史入住' }, component: () => import('../views/front/History') },
      { path: 'person', name: 'Person', meta: { name: '个人信息' }, component: () => import('../views/front/Person') },
      { path: 'roleList', name: 'RoleList', meta: { name: '角色管理' }, component: () => import('../views/front/RoleList') },
      { path: 'customerEdit/:id?/:detailId?', name: 'CustomerEdit', meta: { name: '管理员信息' }, component: () => import('../views/front/CustomerEdit') },
      { path: 'roleEdit/:id?', name: 'RoleEdit', meta: { name: '编辑角色管理' }, component: () => import('../views/front/RoleEdit') },
      { path: 'userList', name: 'UserList', meta: { name: '用户管理' }, component: () => import('../views/front/UserList') },
      { path: 'hotel', name: 'Hotel', meta: { name: '酒店信息' }, component: () => import('../views/front/Hotel') },
      { path: 'hotelList', name: 'HotelList', meta: { name: '场地列表' }, component: () => import('../views/front/HotelList') },
      { path: 'hotelMap', name: 'HotelMap', meta: { name: '场地地图' }, component: () => import('../views/front/HotelMap') },
      { path: 'venueFinder', name: 'VenueFinder', meta: { name: '地图找场地' }, component: () => import('../views/front/VenueFinder') },
      { path: 'hotelDetail/:id?', name: 'HotelDetail', meta: { name: '场地详情' }, component: () => import('../views/front/HotelDetail') },
      { path: 'hotelEdit/:id?', name: 'HotelEdit', meta: { name: '编辑场地' }, component: () => import('../views/front/HotelEdit') },
      { path: 'channelList', name: 'ChannelList', meta: { name: '渠道信息列表' }, component: () => import('../views/front/ChannelList') },
      { path: 'channelEdit/:id?', name: 'ChannelEdit', meta: { name: '编辑渠道信息' }, component: () => import('../views/front/ChannelEdit') },
      { path: 'meetingList', name: 'MeetingList', meta: { name: '拜访信息列表' }, component: () => import('../views/front/MeetingList') },
      { path: 'meetingEdit/:id?/:meetId?', name: 'MeetingEdit', meta: { name: '编辑拜访信息' }, component: () => import('../views/front/MeetingEdit') },
      { path: 'customerInformation', name: 'CustomerInformation', meta: { name: '客户信息' }, component: () => import('../views/front/CustomerInformation') },
      { path: 'customerList', name: 'CustomerList', meta: { name: '客户列表' }, component: () => import('../views/front/CustomerList') },
      { path: 'userEdit/:id?', name: 'UserEdit', meta: { name: '编辑用户' }, component: () => import('../views/front/UserEdit') },
      { path: 'detail', name: 'Detail', meta: { name: '客房信息' }, component: () => import('../views/front/Detail') },
      { path: 'collect', name: 'Collect', meta: { name: '收藏信息' }, component: () => import('../views/front/Collect') },
      { path: 'orders', name: 'Orders', meta: { name: '订单信息' }, component: () => import('../views/front/Orders') },
      { path: 'requireList', name: 'RequireList', meta: { name: '订单列表' }, component: () => import('../views/front/RequireList') },
      // 8-27 邱总：供应商自己维护资料
      { path: 'myProfile', name: 'MyProfile', meta: { name: '我的资料' }, component: () => import('../views/front/MyProfile') },
      { path: 'requirementInput/:id?', name: 'RequirementInput', meta: { name: '订单录入' }, component: () => import('../views/front/RequirementInput') },
      { path: 'requirementDetail/:id?', name: 'RequirementDetail', meta: { name: '订单详情' }, component: () => import('../views/front/RequirementDetail') },
      { path: 'requirementMatch/:id?', name: 'RequirementMatch', meta: { name: '酒店匹配' }, component: () => import('../views/front/RequirementMatch') },
      { path: 'quotationSummary/:id?', name: 'QuotationSummary', meta: { name: '报价单' }, component: () => import('../views/front/QuotationSummary') },
      { path: 'search', name: 'Search', meta: { name: '搜索页面' }, component: () => import('../views/front/Search') },
      { path: 'hotelExport', name: 'HotelExport', meta: { name: '酒店导出' }, component: () => import('../views/front/HotelExport') },
      { path: 'loginImageManage', name: 'LoginImageManage', meta: { name: '登录图管理' }, component: () => import('../views/front/LoginImageManage') },
      { path: 'statsDashboard', name: 'StatsDashboard', meta: { name: '统计看板' }, component: () => import('../views/front/StatsDashboard') },
      { path: '403', name: 'Front403', meta: { name: '无权限' }, component: () => import('../views/manager/403') },
    ]
  },
  { path: '/login', name: 'Login', meta: { name: '登录' }, component: () => import('../views/Login.vue') },
  // 同域分入口：/admin/login 内部运营，/portal/login 外部酒店/渠道
  { path: '/admin/login', name: 'AdminLogin', meta: { name: '运营后台登录', mode: 'admin' }, component: () => import('../views/Login.vue') },
  { path: '/portal/login', name: 'PortalLogin', meta: { name: '合作伙伴门户登录', mode: 'portal' }, component: () => import('../views/Login.vue') },
  { path: '/quotationDemand/:demandId?/:supplierId?', name: 'QuotationDemand', meta: { name: '酒店报价' }, component: () => import('../views/QuotationDemand.vue') },
  // 8-27 邱总：供应商从邮件点进来传报价单的那一页，不用登录
  { path: '/supplierUpload/:demandId/:channelId', name: 'SupplierUpload', meta: { name: '供应商上传' }, component: () => import('../views/SupplierUpload.vue') },
  { path: '/register', name: 'Register', meta: { name: '注册' }, component: () => import('../views/Register.vue') },
  { path: '*', name: 'NotFound', meta: { name: '无法访问' }, component: () => import('../views/404.vue') },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 9-30 邱总：渠道进去能看到匹配页 —— 这些正则原来分大小写，系统里跳转多用大写 RequirementMatch，
// 路由本身不分大小写能进去 守卫却一条都对不上 直接放行。一律加 i
// 角色访问白名单：path 前缀 → 允许的 roleIds（'1'=管理员 '2'=员工 '3'=酒店销售 '4'=渠道 '5'=供应商）
const ROLE_ACCESS = [
  { match: /^\/front\/customer/i, roles: ['1', '2'] },
  { match: /^\/front\/channel/i, roles: ['1', '2'] },
  { match: /^\/front\/(role|user)List/i, roles: ['1'] },
  { match: /^\/front\/(roleEdit|userEdit)/i, roles: ['1'] },
  { match: /^\/front\/loginImageManage/i, roles: ['1'] },
  { match: /^\/front\/statsDashboard/i, roles: ['1', '2'] },
  // 9-30：场地地图 地图找场地 菜单本来只给管理员员工 守卫表里漏了（地图找场地谁都能进）
  { match: /^\/front\/(hotelMap|venueFinder)/i, roles: ['1', '2'] },
  { match: /^\/front\/hotelExport/i, roles: ['1', '2'] },
  { match: /^\/front\/hotel/i, roles: ['1', '2', '3'] },
  { match: /^\/front\/requirementMatch/i, roles: ['1', '2'] },
  // 9-30：报价单里是所有酒店的报价 列表上查看报价单的按钮本来就只给管理员员工 守卫这里却放了酒店销售
  { match: /^\/front\/quotationSummary/i, roles: ['1', '2'] },
  { match: /^\/front\/(requireList|requirementDetail)/i, roles: ['1', '2', '3', '4', '5'] },
  { match: /^\/front\/requirementInput/i, roles: ['1', '2', '3', '4'] },
  { match: /^\/front\/meeting/i, roles: ['1', '2'] },
]

router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/register' || to.path === '/' || to.path.startsWith('/quotationDemand') || to.path.startsWith('/supplierUpload') || to.path === '/front/person' || to.path === '/front/403') {
    return next()
  }
  let user = {}
  try {
    const raw = $local.get('user')
    if (raw) user = JSON.parse(raw)
  } catch (e) {}
  const roleIds = String(user?.roleIds || '').split(',').filter(Boolean)
  if (!roleIds.length) return next()
  for (const rule of ROLE_ACCESS) {
    if (rule.match.test(to.path)) {
      const allowed = rule.roles.some(r => roleIds.includes(r))
      if (!allowed) return next('/front/403')
      break
    }
  }
  next()
})

export default router